__turbopack_context__.v({
  "productCategoryPage": "ProductCategory-module-scss-module__j_sc7W__productCategoryPage",
  "productRows": "ProductCategory-module-scss-module__j_sc7W__productRows",
  "rowDivider": "ProductCategory-module-scss-module__j_sc7W__rowDivider",
});
